import Mutations from '../../odata/mutations';

export default {
  ...new Mutations('xeroContact'),
  ...new Mutations('xeroContacts'),
  ...new Mutations('xeroClients'),
  ...new Mutations('xeroSuppliers'),
};
